import { render, staticRenderFns } from "./productRadar.vue?vue&type=template&id=b202ce34&scoped=true"
import script from "./productRadar.vue?vue&type=script&lang=js"
export * from "./productRadar.vue?vue&type=script&lang=js"
import style0 from "./productRadar.vue?vue&type=style&index=0&id=b202ce34&prod&lang=scss"
import style1 from "./productRadar.vue?vue&type=style&index=1&id=b202ce34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b202ce34",
  null
  
)

export default component.exports